import React from 'react';
import { exclamation } from '../../assets/icons';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { RoutesE } from '../../routes/routesData';

import styles from './notFound.module.scss';

/**
 * Default plug for not existed pages
 * */

const NotFound = () => {
    const navigate = useNavigate();

    const handleGoHomeClick = () => {
        navigate(RoutesE.HOME);
    };

    return (
        <main className={styles.mainWrapper}>
            <img src={exclamation} alt="Error 404" />
            <h1>Page not found</h1>
            <h2>404</h2>
            <Button onClick={handleGoHomeClick}>Go to main page</Button>
        </main>
    );
};

export default NotFound;